import React from 'react';
import BN from 'bignumber.js';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import Button from '@material-ui/core/Button';
import stylesParent from '../../../styles/frame/frame.module.scss';
import styles from '../../../styles/unstake/unstake-details.module.scss';
import ClaimBg from '../../../../../../../assets/images/LIGHT_CLAIM_ILLUSTRATION.svg';
import Header from '../../../../../../../components/Stake/header';
import {
  OM,
  SHORT_CLAIM_PERIOD,
  LONG_CLAIM_PERIOD,
  CHAIN_NAMES,
  SHORT_CLAIM_PENALTY,
} from '../../../../../../../constants/blockchain-constants';
import OmIcon from '../../../../../../../assets/images/tokens/om-v2.svg';
import { useGetTheme } from '../../../../../../../hooks/useGetTheme';
import { formatToken } from '../../../../../../../helpers/token-helper';
import { claimRewards } from '../../../../../../../actions/account-polkadot-actions';

const ClaimDetails = ({ setStatus, long }) => {
  const colors = useGetTheme();
  const dispatch = useDispatch();
  const unclaimedAmount = useSelector((state) => state.delegator.polkadot.unclaimedAmount);
  const amountToClaim = long
    ? unclaimedAmount
    : new BN((1 - SHORT_CLAIM_PENALTY) * unclaimedAmount).toString(10);

  const sendClaim = async () => {
    try {
      dispatch(claimRewards(unclaimedAmount, long, CHAIN_NAMES.POLKADOT));
    } catch (e) {
      setStatus(99);
    }
  };

  return (
    <>
      <Header icon={OmIcon} title='OM-Claim' onClickBack={() => setStatus(3)} />
      <div className={stylesParent.cardContent} style={{ color: colors.text }}>
        <div className={styles.title}>You Are Claiming</div>
        <div className={styles.value}>
          {formatToken(amountToClaim)} {OM}
        </div>
        <img className={styles.image} src={ClaimBg} alt='' />
        <div>
          <div className={styles.descriptionItem}>
            {long ? (
              <>
                <span>*</span> There is a <span>{LONG_CLAIM_PERIOD} day claiming period</span>{' '}
                before you are able to withdraw your unclaimed tokens. Following that{' '}
                {LONG_CLAIM_PERIOD} day claiming period, users will be able to withdraw their
                rewards.
              </>
            ) : (
              <>
                <span>*</span> There is a <span>30 day claiming period</span> before you are able to
                withdraw your unclaimed tokens. Following that {SHORT_CLAIM_PERIOD} day claiming
                period, users will be able to withdraw their rewards.
              </>
            )}
          </div>
        </div>
        <div className={stylesParent.cardFooterControls}>
          <Button
            onClick={() => sendClaim()}
            variant='contained'
            color='secondary'
            className={stylesParent.cardFooterControlsButton}
          >
            Claim Rewards
          </Button>
        </div>
      </div>
    </>
  );
};

ClaimDetails.propTypes = {
  setStatus: PropTypes.func.isRequired,
  long: PropTypes.bool,
};

ClaimDetails.defaultProps = {
  long: false,
};

export default ClaimDetails;
